import { createStyles, makeStyles, Typography } from '@material-ui/core'
import React from 'react'
import { ReactComponent as LoadingSvg } from '../Assets/loading.svg'
import { Config } from '../../config'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      fontFamily: 'Montserrat',
      height: '100vh',
      background:
        'linear-gradient(180deg, rgba(51, 51, 51, 0.2) 0%, #333333 100%), linear-gradient(197.24deg, #46A4E0 0%, #246193 98.81%)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      color: '#fff'
    },
    title: {
      fontSize: '144px',
      fontWeight: 'bold',
      margin: 20
    },
    loading: {
      margin: 20
    }
  })
)

const Download: React.FC = () => {
  const classes = useStyles()
  const [isOnline, setNetwork] = React.useState(window.navigator.onLine)

  const updateNetwork = () => {
    console.log(window.navigator.onLine)
    setNetwork(window.navigator.onLine)
  }

  React.useEffect(() => {
    window.addEventListener('offline', updateNetwork)
    window.addEventListener('online', updateNetwork)
    return () => {
      window.removeEventListener('offline', updateNetwork)
      window.removeEventListener('online', updateNetwork)
    }
  })

  return (
    <div className={classes.root}>
      <Typography className={classes.title} align="center">
        {Config.name}
      </Typography>
      <Typography align="center" variant="h2">
        {isOnline
          ? 'Aguarde, atualizando...'
          : 'Sem conexão com internet, tente novamente'}
      </Typography>
      <div className={classes.loading}>{isOnline && <LoadingSvg />}</div>
    </div>
  )
}

export default Download
